module.exports = __webpack_public_path__ + "Simple-Line-Icons.d2285965fe34b0546504.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module id = ../../../../../src/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module chunks = 2